export default __webpack_public_path__ + "static/media/Posti_Group.svg.08d1a1f3.png";